module.exports = __webpack_public_path__ + "static/img/1609_phase_function_Paper_Points.83a58e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1609_phase_function_Paper_Points.png
// module id = LoqT
// module chunks = 0